import { Alert, Box } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation";
import AiUsageBox from "../aiUsageBox/AiUsageBox";
import { AiSpendingBreakdown } from "../AiAdministration.types";
import { DotLegalAlert } from "@dotlegal/dotlegal-ui-components";

export interface UsageForCurrentMonthBoxProps {
    monthlySpendingLimitEur: number | null;
    breakdown: AiSpendingBreakdown | null;
    isLoading?: boolean;
    hasWelcomeCreditBeenExhausted?: boolean;
}

function UsageForCurrentMonthBox(props: UsageForCurrentMonthBoxProps) {
    const { translateString } = useTranslation();

    const usage = {
        contractCreations: props.breakdown?.contractCreation ?? 0,
        obligationExtractions: props.breakdown?.obligationExtraction ?? 0,
        documentScans: props.breakdown?.qualityScanOfDocuments ?? 0,
        chats: props.breakdown?.chat ?? 0,
    };

    const totalUsage = usage.contractCreations + usage.obligationExtractions + usage.documentScans + usage.chats;
    const hasReachedLimit = props.hasWelcomeCreditBeenExhausted && props.monthlySpendingLimitEur !== null && totalUsage >= props.monthlySpendingLimitEur;

    return (
        <AiUsageBox
            header={translateString("usageForCurrentMonth")}
            limit={props.monthlySpendingLimitEur ?? 0}
            usage={usage}
            isLoading={props.isLoading}
            headerMargin={3}
            footer={
                hasReachedLimit && (
                    <Box sx={{ marginTop: 2, marginLeft: 6, marginRight: 6 }}>
                        <DotLegalAlert severity="warning" warningText={translateString("monthlyUsageLimitReachedWarning")}></DotLegalAlert>
                    </Box>
                )
            }
        />
    );
}

export default UsageForCurrentMonthBox;
